import React from "react";
import Footer from "../Footer/Footer";

const TermsConditions = () => {
  return (
    <>
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1 className="title">TERMS AND CONDITIONS</h1>
          <h5>Effective Date: 1/01/2025</h5>
          <p>
            <em>
              Welcome to <a href="https://gettrendy.in/">Gettrendy.in</a>! These
              Terms and Conditions ("Terms") govern your use of our website and
              services. By accessing or using <a href="https://gettrendy.in/">Gettrendy.in</a>, you agree to
              comply with these Terms. If you do not agree, please refrain from
              using our website.
            </em>
          </p>
          <ol>
            <li>
              <strong>General</strong>
              <p>
                1.1 <a href="https://gettrendy.in/">Gettrendy.in</a> is
                Privately held, a registered business in Pune.
              </p>
              <p>
                1.2 We reserve the right to update or modify these Terms at any
                time without prior notice. Continued use of the website
                constitutes acceptance of the revised Terms.
              </p>
            </li>
            <li>
              <strong>Use of the Website</strong>
              <p>2.1. You must be at least 18 years old to use this website.</p>
              <p>
                2.2. You agree not to use the website for any unlawful purposes
                or in violation of any applicable laws.
              </p>
              <p>
                2.3. We reserve the right to refuse service, terminate accounts,
                or remove content at our sole discretion.
              </p>
            </li>
            <li>
              <strong>Products and Orders</strong>
              <p>
                3.1. All products listed on{" "}
                <a href="https://gettrendy.in/">Gettrendy.in</a> are subject to
                availability.
              </p>
              <p>
                3.2. We strive to ensure accurate pricing and descriptions;
                however, errors may occur, and we reserve the right to correct
                them.
              </p>
              <p>
                3.3. Placing an order constitutes an offer to purchase, which we
                may accept or decline at our discretion.
              </p>
            </li>
            <li>
              <strong>Payment and Pricing</strong>
              <p>
                4.1. Prices are listed in INR and are inclusive/exclusive of
                applicable taxes as specified.
              </p>
              <p>
                4.2. Payment can be made via credit/debit cards, UPI, net
                banking, or other methods provided at checkout.
              </p>
              <p>
                4.3. In case of payment failure, the order will not be processed
                until payment is successfully received.
              </p>
            </li>
            <li>
              <strong>Shipping and Delivery</strong>
              <p>
                5.1. Orders will be processed and shipped within the estimated
                time frame mentioned on the website.
              </p>
              <p>
                5.2. Shipping charges and delivery timelines may vary based on
                location and shipping method chosen.
              </p>
              <p>
                5.3. We are not responsible for delays caused by courier
                partners or unforeseen circumstances.
              </p>
            </li>
            <li>
              <strong>Returns and Refunds</strong>
              <p>
                6.1. Returns are accepted within 3 days of delivery, subject to
                our return policy.
              </p>
              <p>
                6.2. Products must be unused, in original condition, and with
                tags intact to qualify for a return.
              </p>
              <p>
                6.3. Refunds will be processed within 7 business days after the
                returned product is received and inspected.
              </p>
            </li>
            <li>
              <strong>Intellectual Property</strong>
              <p>
                7.1. All content on{" "}
                <a href="https://gettrendy.in/">Gettrendy.in</a>, including
                logos, images, and text, is the property of{" "}
                <a href="https://gettrendy.in/">Gettrendy.in</a> and protected
                under applicable intellectual property laws.
              </p>
              <p>
                7.2. Unauthorized use or reproduction of any content is strictly
                prohibited.
              </p>
            </li>
            <li>
              <strong>Limitation of Liability</strong>
              <p>
                8.1. <a href="https://gettrendy.in/">Gettrendy.in</a> shall not
                be liable for any indirect, incidental, or consequential damages
                arising from the use of our website or products.
              </p>
              <p>
                8.2. Our total liability in any case shall not exceed the amount
                paid for the specific product purchased.
              </p>
            </li>
            <li>
              <strong>Privacy Policy</strong>
              <p>
                9.1. Your use of{" "}
                <a href="https://gettrendy.in/">Gettrendy.in</a> is also
                governed by our Privacy Policy, which outlines how we collect,
                use, and protect your personal information.
              </p>
            </li>
            <li>
              <strong>Governing Law</strong>
              <p>
                10.1. These Terms are governed by the laws of Pune, and any
                disputes shall be subject to the exclusive jurisdiction of
                courts in Pune.
              </p>
            </li>
            <li>
              <strong>Contact Information</strong>
              <p>
                If you have any questions or concerns about these Terms, please
                contact us at:
              </p>
            </li>
          </ol>
          <ul style={{ listStyle: "none" }}>
            <li>Email: supportgettrendy.in@gmail.com </li>
            <li>Phone: 9096321038</li>
          </ul>
          <h6>
            Thank you for shopping with{" "}
            <a href="https://gettrendy.in/">Gettrendy.in</a>!
          </h6>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default TermsConditions;
